import * as React from 'react'
import { compose, pure } from 'recompose'

import ActionButton from '../../atoms/ActionButton/ActionButton'

import * as styles from './FooterButton.css'

interface FooterButtonProps {
  children: any
  isEnabled?: boolean
  isLoading?: boolean
  handleClick?: () => void
  id?: string
}

const FooterButton: React.FunctionComponent<FooterButtonProps> = ({
  children,
  isEnabled = true,
  handleClick,
  isLoading = false,
  id
}) => (
  <div className={styles.footer} id={id}>
    <ActionButton isEnabled={isEnabled} handleClick={handleClick} isLoading={isLoading}>
      {children}
    </ActionButton>
  </div>
)
export default compose<FooterButtonProps, FooterButtonProps>(pure)(FooterButton)
